var Handlebars = require("/builds/product/cm/hyperchat-sdk/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "La invitación saltará a otro agente en "
    + ((stack1 = ((helper = (helper = helpers.ttl || (depth0 != null ? depth0.ttl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ttl","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "s\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./i18n/es_ES/invitation_expiring.hbs
// module id = 280
// module chunks = 0